export default "/* purgecss start ignore */\n\n::ng-deep .mat-dialog-container {\n  overflow-y: hidden !important;\n}\n\n/* purgecss end ignore */";